import { Component, OnChanges, Input, ViewEncapsulation, inject } from '@angular/core';
import { PictureService } from 'src/services';
import { combineLatest, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'ma-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [AsyncPipe],
})
export class ImageSliderComponent implements OnChanges {
  private readonly pictureService = inject(PictureService);

  @Input()
  pictureIds: string[];

  pictures$: Observable<any[]>;

  ngOnChanges() {
    this.getPictures();
  }

  getPictures() {
    this.pictures$ = combineLatest(
      (this.pictureIds || []).map((pictureId) => {
        return this.pictureService.getPictureUrl$(pictureId).pipe(
          map((taskPictureUrl) => {
            return {
              image: taskPictureUrl,
              thumbImage: taskPictureUrl,
              alt: 'An Image',
              title: '',
            };
          }),
          catchError(() => of(null))
        );
      })
    ).pipe(map((images) => images.filter((image) => !!image)));
  }
}
